// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"busDate": "",
		"clinicId": '',
		"costAmt": '',
		"createId": '',
		"createTime": "",
		"docNum": "",
		"id": '',
		"list": [
			{
				"clinicId": '',
				"drugId": '',
				"drugName": "",
				"drugSpec": "",
				"id": '',
				"invId": '',
				"manuLotnum": "",
				"nullifyCnt": '',
				"nullifyDocId": '',
				"nullifyId": '',
				"nullifyState": '',
				"nullifyTime": "",
				"nullifyWaitCnt": '',
				"pacCnt": '',
				"prodentpName": "",
				"prodentpNameId": '',
				"purcType": "",
				"retnAmt": '',
				"retnCnt": '',
				"purcCnt":'',
				"retnId": '',
				"pacSpec":'',
				"retnPric": '',
				"saleAmt": '',
				"salePric": '',
				"unt": ""
			}
		],
		"nullifyB": '',
		"nullifyId": '',
		"nullifyTime": "",
		"passingOrdersId": '',
		"passingOrdersTime": "",
		"phayId": 3,
		"remarks": "",
		"retnTypeId": 15,
		"reviewId": '',
		"reviewTime": "",
		"saleAmt": '',
		"state": '',
		"supplyCandidateId": '',
		"terminalId": ""
	}
]

